const imageDataCache = new Map();

export default imageDataCache;
